/* eslint-disable import/prefer-default-export */
import { GET_WALL_CHART } from './types'
import { Standing } from '../../apis'

export const getWallChart = (accessToken, tournamentId, params = {}) => async (dispatch) => {
  const standing = new Standing(accessToken, dispatch)
  const func = async () => standing.getWallChart(tournamentId, params)
  return standing.d(func, GET_WALL_CHART)
}
